import React from 'react';
import { ReactTyped } from "react-typed";

const MotionType = ({ text = "", setDisable, maxDuration = 4000 }) => {
    if (!text) return null;

    const length = text.length;

    // Calculate typeSpeed so total typing time stays under `maxDuration`
    // typeSpeed = ms per character
    let calculatedSpeed = Math.floor(maxDuration / length);

    // Set bounds so speed isn't too fast or slow
    const typeSpeed = Math.max(10, Math.min(calculatedSpeed, 100));

    return (
        <>
            <ReactTyped
                strings={[text ?? ""]}
                typeSpeed={typeSpeed}
                // typeSpeed={20}  // Typing speed
                backSpeed={50}   // Speed of backspacing
                backDelay={1000} // Delay before starting to backspace
                startDelay={500} // Delay before typing starts
                loop={false}     // Disable looping
                showCursor={false} // Remove cursor after typing
                onBegin={() => setDisable(true)}
                // onStart={()=>console.log("start",true)}
                onComplete={() => setDisable(false)}
            />
        </>
    );
};

export default MotionType;


